import React from 'react';
import Slider from 'react-slick';

import { CompItemRemote } from './comp-item-remote';
import { ascSort } from '@common/helpers/declarative/sortings';

import './style.scss';

const FavoriteCompetitionsRemote = ({ slidesData }) => {
  const list = ['BottomLeft', 'BottomCenter', 'BottomRight']
    .map(key => [key, slidesData?.[key]])
    .filter(([, value]) => Boolean(value));

  return (
    <div className="home-favorite-competitions home-favorite-competitions-remote">
      {list.map(([key, comp]) => {
        if (comp.length === 1) return <CompItemRemote key={key} {...comp[0]} />;

        const sorted = [...comp].sort(ascSort('index'));

        return (
          <div key={key} className="home-comp-slides">
            <Slider
              dots={false}
              accessibility={false}
              arrows={false}
              autoplay
              infinite
              draggable
              autoplaySpeed={5000}
              dragging={false}
              slidesToShow={1}
              slidesToScroll={1}
            >
              {sorted.map((item, index) => (
                <CompItemRemote key={index} {...item} />
              ))}
            </Slider>
          </div>
        );
      })}
    </div>
  );
};

export default FavoriteCompetitionsRemote;
